import React, { lazy } from 'react';
import { PriceDisplay } from './PriceDisplay';
import { usePricing } from '../contexts/PricingContext';
import { Check } from 'lucide-react';
export function FinalCTA() {
  const cartLink = 'https://superlibrodigital.com/cart/clear?return_to=/cart/add?id=56060036874566&quantity=1';
  const {
    formatBonusPrice,
    isLoading
  } = usePricing();
  // Total value of all items in USD
  const totalUsdValue = 171.99;
  return <section className="py-10 md:py-20 bg-navy-900 text-white text-center content-section" data-id="element-138">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-139">
        <h2 className="font-heading text-2xl md:text-5xl font-bold text-white mb-4 md:mb-8" data-id="element-140">
          Una Vez Más,{' '}
          <span className="highlight-burgundy text-gold-100" data-id="element-141">
            Todo Lo Que Recibirás
          </span>
        </h2>

        <div className="mb-6 md:mb-10" data-id="element-142">
          <img src="https://cdn.magicpatterns.com/uploads/jHTFRKJ1XAzMCT8Exd7ZtM/ChatGPT_Image_1_mar_2026,_09_49_20_a.m..png" alt="Biblia Visual — Paquete Completo con todos los bonos" loading="lazy" width="600" height="400" className="w-full max-w-sm md:max-w-2xl mx-auto rounded-xl shadow-2xl" data-id="element-143" />
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-6 md:mb-10 text-sm md:text-base text-gray-300" data-id="element-144">
          <span className="flex items-center" data-id="element-145">
            <Check className="w-4 h-4 text-gold-500 mr-2" data-id="element-146" />{' '}
            <span className="font-bold text-white" data-id="element-147">Acceso a Biblia Visual</span>
          </span>
          <span className="flex items-center" data-id="element-148">
            <Check className="w-4 h-4 text-gold-500 mr-2" data-id="element-149" />{' '}
            <span data-id="element-150">
              500+ páginas,{' '}
              <span className="font-bold text-gold-200" data-id="element-151">280+ imágenes HD</span>
            </span>
          </span>
          <span className="flex items-center" data-id="element-152">
            <Check className="w-4 h-4 text-gold-500 mr-2" data-id="element-153" /> Formato Digital
          </span>
          <span className="flex items-center" data-id="element-154">
            <Check className="w-4 h-4 text-gold-500 mr-2" data-id="element-155" />{' '}
            <span className="font-bold text-gold-400" data-id="element-156">
              7 Bonus Incluidos Gratis
            </span>
          </span>
          <span className="flex items-center" data-id="element-157">
            <Check className="w-4 h-4 text-gold-500 mr-2" data-id="element-158" /> Actualizaciones de
            por vida
          </span>
          <span className="flex items-center" data-id="element-159">
            <Check className="w-4 h-4 text-gold-500 mr-2" data-id="element-160" />{' '}
            <span className="underline-subtle text-white" data-id="element-161">
              Garantía de 120 días
            </span>
          </span>
        </div>

        <div className="bg-navy-800 rounded-2xl p-5 md:p-8 border border-navy-700 max-w-2xl mx-auto shadow-2xl" data-id="element-162">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-4 md:mb-6" data-id="element-163">
            <div className="text-gray-400" data-id="element-164">
              <p className="text-sm uppercase tracking-wide" data-id="element-165">Valor total</p>
              <p className="text-xl line-through decoration-red-500 font-medium" data-id="element-166">
                {isLoading ? '...' : formatBonusPrice(totalUsdValue)}+
              </p>
            </div>
            <div className="hidden md:block w-px h-12 bg-gray-700" data-id="element-167"></div>
            <div data-id="element-168">
              <p className="text-sm text-gold-400 uppercase font-bold tracking-wider" data-id="element-169">
                Pago único hoy
              </p>
              <PriceDisplay type="current" className="text-4xl md:text-5xl font-bold text-white text-shadow-gold" data-id="element-170" />
            </div>
          </div>

          <a href={cartLink} className="block w-full bg-gradient-to-r from-gold-500 to-amber-600 hover:from-gold-600 hover:to-amber-700 text-white font-bold py-4 md:py-5 px-6 rounded-lg shadow-lg hover:shadow-gold-500/30 transition-all transform hover:-translate-y-1 text-xl uppercase tracking-wide will-change-transform" data-id="element-171">
            AGREGAR AL CARRITO »
          </a>
          <p className="text-gray-400 text-sm mt-3" data-id="element-172">
            Acceso inmediato a{' '}
            <span className="font-bold text-gray-300" data-id="element-173">Biblia Visual</span> +{' '}
            <span className="font-bold text-gold-400" data-id="element-174">Todos los Bonos</span>
          </p>
        </div>
      </div>
    </section>;
}